import React from 'react';
import { ExternalLink } from 'platform/react-router';
import { Prompt } from 'sellDirect/components/offer/Prompt';

const MARKET_CONDITIONS_BLOG_LINK =
  'https://www.opendoor.com/w/blog/navigating-changing-market-conditions';

export enum OfferStage {
  PRE_UW = 'pre-uw',
  POST_UW = 'post-uw',
}
type BlogLinkProps = {
  href: string;
  analyticsPrefix: string;
};
/**
 * Displays an external link to one of our blog posts
 * this one is specifically for market conditions and it tracks user clicks based on
 * where in the flow they clicked into the blog, either pre or post underwriting.
 */
const BlogLink: React.FC<BlogLinkProps> = ({ href, analyticsPrefix }) => {
  return (
    <ExternalLink
      href={href}
      analyticsName={`cake-${analyticsPrefix}-market-conditions-blog-link`}
      target="_blank"
      aria-label="Opens new tab to a blog post with details about market conditions"
      textDecoration="underline"
      color="neutrals100"
    >
      Learn more
    </ExternalLink>
  );
};
type DisappointmentMessagingPromptProps = {
  offerStage: OfferStage;
};
/**
 * Message card to prompt customers on reducing disappointment.
 * Links out to a blog post with more details about market conditions
 * component-test-check-ignore
 */
export const DisappointmentMessagingPrompt: React.FC<DisappointmentMessagingPromptProps> = ({
  offerStage,
}) => (
  <Prompt
    title={
      offerStage === OfferStage.POST_UW
        ? 'We always try to make our best offer.'
        : 'Market uncertainty is impacting this offer.'
    }
    body={
      offerStage === OfferStage.POST_UW
        ? 'However, due to market uncertainty this offer may be lower than you expect.'
        : 'We’ll refresh it every few weeks so you have our best and most up-to-date offer.'
    }
  >
    <BlogLink href={MARKET_CONDITIONS_BLOG_LINK} analyticsPrefix={offerStage} />
  </Prompt>
);
